export default __webpack_public_path__ + "static/media/i150vp.ae5e250f.webp";